import { WidgetLazyLoader } from 'components/common/WidgetLazyLoader';
import { configuration } from 'config/constants';
import React, { FC } from 'react';

declare global {
    namespace React {
        namespace JSX {
            interface IntrinsicElements {
                'sgwt-connect': any;
            }
        }
    }
}

export const SgwtConnect: FC = () => {
    return <WidgetLazyLoader script={`${configuration.widgetCdnBaseUrl}/widgets/sgwt-connect/v4/sgwt-connect.js`}>
        <sgwt-connect />
    </WidgetLazyLoader>;
};